// This file contains constants related to the game board layout, dimensions and assets.

export const BOARD_DEBUG_RENDERING: boolean = false;

// Layout Constants

export const BOARD_PADDING: [number, number, number, number] = [175, 160, 570, 370];
export const BOARD_POINT_WIDTH: number = 215;
export const BOARD_DICE_AREA: [number, number, number, number] = [85, 330, 200, 635];

export const BOARD_BAR1_OFFSET: [number, number] = [100, 540];
export const BOARD_BAR2_OFFSET: [number, number] = [100, 315];
export const BOARD_BAR_AREA_SIZE: [number, number] = [200, 235];

export const BOARD_BEAR1_OFFSET: [number, number] = [85, 275];
export const BOARD_BEAR2_OFFSET: [number, number] = [85, 5];
export const BOARD_BEAR_AREA_SIZE: [number, number] = [200, 275];

export const POINT_HIGHLIGHT_OFFSET: number = 20;
export const POINT_CHECKER_SCALE: number = 0.85;
